<template>
  <svg
    width="216"
    height="162"
    viewBox="0 0 216 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M108 152C148.869 152 182 146.627 182 140C182 133.373 148.869 128 108 128C67.1309 128 34 133.373 34 140C34 146.627 67.1309 152 108 152Z"
      fill="#E7E8E9"
    />
    <path
      d="M52 72C52 83.8669 55.5189 95.4673 62.1118 105.334C68.7047 115.201 78.0754 122.892 89.039 127.433C100.003 131.974 112.067 133.162 123.705 130.847C135.344 128.532 146.035 122.818 154.426 114.426C162.818 106.035 168.532 95.3443 170.847 83.7054C173.162 72.0666 171.974 60.0026 167.433 49.039C162.892 38.0754 155.201 28.7047 145.334 22.1118C135.467 15.5189 123.867 12 112 12V36C119.12 36 126.08 38.1114 132.001 42.0671C137.921 46.0228 142.535 51.6453 145.26 58.2234C147.984 64.8015 148.697 72.0399 147.308 79.0232C145.919 86.0066 142.491 92.4212 137.456 97.4558C132.421 102.491 126.007 105.919 119.023 107.308C112.04 108.697 104.802 107.984 98.2234 105.26C91.6453 102.535 86.0228 97.9207 82.0671 92.0005C78.1114 86.0804 76 79.1201 76 72H52Z"
      fill="#97D3C6"
    />
    <path
      d="M112 12C119.879 12 127.681 13.5519 134.961 16.5672C142.241 19.5825 148.855 24.0021 154.426 29.5736C159.998 35.1451 164.417 41.7595 167.433 49.039C170.448 56.3185 172 64.1207 172 72H148C148 67.2724 147.069 62.5911 145.26 58.2234C143.45 53.8557 140.799 49.8871 137.456 46.5442C134.113 43.2012 130.144 40.5495 125.777 38.7403C121.409 36.9312 116.728 36 112 36V12Z"
      fill="#53B7A1"
    />
    <path
      d="M172 72C172 81.4608 169.763 90.7876 165.471 99.2189C161.179 107.65 154.954 114.947 147.304 120.514L133.183 101.108C137.772 97.7683 141.507 93.3901 144.083 88.3313C146.658 83.2726 148 77.6765 148 72H172Z"
      fill="#3F9784"
    />
    <path
      d="M147.263 120.544C138.044 127.241 127.107 131.174 115.734 131.884L114.24 107.93C121.064 107.505 127.626 105.145 133.158 101.126L147.263 120.544Z"
      fill="#DBF0EB"
    />
    <path
      d="M67.4023 112.138C57.5158 101.153 52.0313 86.9054 52.0001 72.1267L76.0001 72.076C76.0188 80.9433 79.3095 89.4917 85.2414 96.0827L67.4023 112.138Z"
      fill="#2F6F61"
    />
    <path
      d="M104 4C88.087 4 72.8258 10.3214 61.5736 21.5736C50.3214 32.8258 44 48.087 44 64H104V4Z"
      fill="#97D3C6"
    />
    <path
      d="M104 4C96.1207 4 88.3185 5.55195 81.039 8.56723C73.7595 11.5825 67.1451 16.0021 61.5736 21.5736L104 64V4Z"
      fill="#3F9784"
    />
  </svg>
</template>
